import React from "react";
import { Dialog } from "@vitalsource/vstui";

class DialogWithRefocus extends React.Component {
  constructor() {
    super();
    this.state = { refocusElement: null };
  }

  componentDidMount() {
    const popoverTrigger = document.querySelector(
      "button[aria-controls*=popover][aria-expanded=true]"
    );
    if (popoverTrigger) {
      this.setState({ refocusElement: popoverTrigger });
    }
  }

  componentWillUnmount() {
    if (this.state.refocusElement) {
      setTimeout(() => this.state.refocusElement.focus(), 50);
    }
  }

  render() {
    const { children, ...rest } = this.props;
    return <Dialog {...rest}>{children}</Dialog>;
  }
}

export default DialogWithRefocus;
